import { ApolloLink } from '@apollo/client'

import { DATOCMS_KEY } from 'Config'

function createDatoAuthLink() {
  return new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${DATOCMS_KEY}`,
      },
    })

    return forward(operation)
  })
}

export default createDatoAuthLink
